"use client";

import useDeviceId from "hooks/swr/useDeviceId";
const UserIDLogic = () => {
  useDeviceId();
  return null;
};
export default UserIDLogic;